import { getNextWeekDates } from "b2b/utils/date";
import { useSmlouvyNaroky } from "b2b/api/hooks/";

export default function useFixniNarokyNasledujiciWidget({ ico }) {
  const nextWeek = getNextWeekDates();
  return useSmlouvyNaroky({ ico, ...nextWeek });
}
